import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { AllegatiGenerici } from 'src/app/models/allegati-generici';
import { AllegatiGenericiService } from 'src/app/shared/services/allegati-generici.service';
import * as FileSaver from 'file-saver';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxFileUploaderComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxPopupComponent,
  DxTemplateDirective,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import { Reparti } from 'src/app/models/reparti';

@Component({
  selector: 'app-allegati-generici',
  templateUrl: './allegati-generici.component.html',
  styleUrls: ['./allegati-generici.component.scss'],
  imports: [
    DxTemplateDirective,
    DxDataGridComponent,
    DxLookupComponent,
    DxButtonComponent,
    DxFileUploaderComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxPopupComponent,
    DxiValidationRuleComponent,
    DxiColumnComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxTemplateDirective,
    DxoExportComponent,
    DxLoadPanelComponent
  ],
  standalone: true,
})
export class AllegatiGenericiComponent implements OnInit {
  private agService = inject(AllegatiGenericiService);
  private sanitizer = inject(DomSanitizer);
  private repartiService = inject(RepartiService);

  listGruppi: string[] = [];
  gruppoFilter!: string;
  dsAllegati: any;

  attaching = false;
  gruppoNuovoAllegato = '';
  nomeAllegato: string = '';
  value: any[] = [];

  popupImageVisible = false;
  currentImage!: SafeResourceUrl;

  listReparti: Reparti[] = [];

  visibleLoadPanel = false;

  ngOnInit() {
    this.loadGruppi();
    this.loadReparti();
  }

  loadGruppi() {
    this.agService.listGruppi().subscribe({
      next: (dati) => {
        this.listGruppi = dati;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento cartelle', 'warning');
        }
      },
    });
  }

  loadReparti(){
    this.repartiService.listTemp().subscribe({
      next: res=>{
        this.listReparti = res;
      },
      error: err=>{
        if(err?.error?.title){
          notify(err.error.title, "error");
        }
        else{
          notify("Errore recupero lista reparti", "error");
        }
      }
    })
  }

  onGruppoSelected() {
    if (this.gruppoFilter) {
      this.loadAllegati();
    } else {
      this.dsAllegati = null;
    }
  }

  loadAllegati() {
    this.dsAllegati = null;
    this.dsAllegati = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.agService.listByGruppo(this.gruppoFilter))
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      remove: (key) => {
        return (
          firstValueFrom(this.agService.delete(key))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
      update: (key, values)=>{
        console.log("test");
        return firstValueFrom(this.agService.update(key, values)).catch(
          (error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          },
        );
      }
    });
  }

  onNuovoAllegato() {
    this.attaching = true;
    this.value = [];
    if (this.gruppoFilter) {
      this.gruppoNuovoAllegato = this.gruppoFilter;
    } else {
      this.gruppoNuovoAllegato = '';
    }
  }

  onAnnullaAllegato() {
    this.attaching = false;
  }

  allegaFile(e: any, files: any) {
    const result = e.validationGroup.validate();
    if (result.isValid) {
      const formData = new FormData();
      formData.append('file', files[0]);
      this.visibleLoadPanel = true;
      this.agService
        .allega(this.gruppoNuovoAllegato, this.nomeAllegato, formData)
        .subscribe({
          next: (dati) => {            
            this.visibleLoadPanel = false;
            console.log('Allegato inserito id: ' + dati);
            notify({ message: 'Allegato salvato', width: 300, shading: true });
            this.gruppoFilter = this.gruppoNuovoAllegato;
            this.loadGruppi();
            this.loadAllegati();
            this.attaching = false;
          },
          error: (error) => {
            this.visibleLoadPanel = false;
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore salvataggio allegato', 'warning');
            }
          },
        });
    }
  }

  scaricaFile(allegato: AllegatiGenerici) {
    this.visibleLoadPanel = true;
    this.agService.scarica(allegato.id).subscribe({
      next: (res) => {        
        this.visibleLoadPanel = false;
        FileSaver.saveAs(res, allegato.nomeFile);
      }, 
      error : (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore recupero allegato', 'warning');
        }
      },
    });
  }

  visualizzaFile(allegato: AllegatiGenerici) {
    this.visibleLoadPanel = true;
    this.agService.scarica(allegato.id).subscribe({
      next: (res) => {        
        this.visibleLoadPanel = false;
        const url = window.URL.createObjectURL(res);
        window.open(url);
      },
      error : (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore visualizzazione allegato', 'warning');
        }
      },
    });
  }

  visualizzaImmagine(allegato: AllegatiGenerici) {
    this.visibleLoadPanel = true;
    this.agService.getImmagine(allegato.id).subscribe({
      next: (res) => {
        this.visibleLoadPanel = false;
        this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image;base64,' + res,
        );
        this.popupImageVisible = true;
      },
      error : (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore visualizzazione immagine', 'warning');
        }
      },
    });
  }

  endsWith(str: any, suffix: any) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }

  onExporting(e: any){
    GridExportExcel(
      e,
      'Allegati Generici',
      'Allegati_Generici_' + this.gruppoFilter + '.xlsx',
    );
  }

  getReparto(idReparto: number){
    const reparto = this.listReparti.find(x => x.id == idReparto);
    if(!reparto){
      return '';
    }
    return reparto.codice + ' - ' + reparto.descrizione;
  }

  displayReparto(reparto: Reparti){
    if(!reparto){
      return '';
    }
    return reparto.codice + ' - ' + reparto.descrizione; 
  }
}
